import * as React from 'react';
import { Column, DataTableData } from '../DataTable';
import { Row } from './Row';

export interface BodyProps<T extends DataTableData> {
    /**
     * The items being displayed
     */
    items: T[];
    /**
     * The columns
     */
    columns: Column[];
    /**
     * Function to handle an input change in an input column
     */
    onInputChange?: (itemKey: string, column: Column, value: string) => void;
}

/**
 * This component represents the table body
 */
export class Body<T extends DataTableData> extends React.Component<
    BodyProps<T>
> {
    /**
     * Current background class
     */
    private currentClass: 'odd' | 'even' = 'odd';

    render() {
        return (
            <tbody>
                {this.props.items.length === 0 && (
                    <tr className="odd">
                        <td
                            colSpan={this.props.columns.length}
                            className="dataTables_empty simple-data-table-cell"
                        >
                            No matching records found
                        </td>
                    </tr>
                )}
                {this.props.items.map(item => (
                    <Row
                        key={item.key}
                        className={this.getAndChangeCurrentClass()}
                        columns={this.props.columns}
                        item={item}
                        onInputChange={(column: Column, value: string) => {
                            if (this.props.onInputChange) {
                                this.props.onInputChange(item.key, column, value);
                            }
                        }}
                    />
                ))}
            </tbody>
        );
    }

    /**
     * This will be called when a re-render of a parent component occurs
     * We want to reset the background class when this happens
     * @param _ New props (unused)
     */
    componentWillReceiveProps(_: BodyProps<T>) {
        this.currentClass = 'odd';
    }

    /**
     * Get the current class and change it for the next row
     */
    private getAndChangeCurrentClass() {
        const currentClass = this.currentClass;
        this.currentClass = currentClass === 'even' ? 'odd' : 'even';
        return currentClass;
    }
}
